import { Outlet } from "react-router-dom";

const DashboardLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default DashboardLayout;